import { Component, Inject, NgZone } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormbuilderService } from "src/app/services/formbuilder.service";
import $ from 'jquery';
import { MatSnackBar } from "@angular/material/snack-bar";
import { AsYouType, parsePhoneNumber } from "libphonenumber-js";
declare var $: any;
@Component({
	selector: 'field-properties',
	templateUrl: 'field-properties.component.html',
})

export class FieldPropertiesComponent {

	public dialog: MatDialog;
	fieldType;
	fieldTitle = "";
	fieldOptions = [];
	fieldEmailOptions = [];
	fieldPhoneOptions = [];
	fieldCheckBoxes = [];
	fieldSelectOptions = [];
	fieldRequired: Boolean;
	defaultValue: Boolean;
	openOptions: Boolean = false;
	error = "";
	receiveSms = true;

	constructor(
		public dialogRef: MatDialogRef<FieldPropertiesComponent>,
		private _formBuilderService: FormbuilderService,
		private ngZone: NgZone,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private _snackBar: MatSnackBar
	) {
		this.ngZone.run(() => {
			this.fieldTitle = data.title;
			this.fieldRequired = data.fieldRequired;
			if (data.fieldCheckBoxes.length > 0 && data.fieldCheckBoxes !== "[]" && data.fieldCheckBoxes !== "{}") {
				this.defaultValue = (data.fieldCheckBoxes === 'true');
			} else {
				this.defaultValue = false;
			}
			if (data.fieldSelectOptions.length > 0 && data.fieldCheckBoxes !== "[]" && data.fieldCheckBoxes !== "{}") {
				this.fieldSelectOptions = JSON.parse(data.fieldOptions);
			} else {
				this.fieldSelectOptions = [
					{
						"label": "",
						"value": "",
						"visible": true
					}
				]
			}
			// if (data.fieldOptions.length > 0) {
			// 	this.fieldOptions = JSON.parse(data.fieldOptions);
			// }
			if (data.fieldEmailOptions.length > 0) {
				this.fieldEmailOptions = JSON.parse(data.fieldEmailOptions);
			}
			if (data.fieldPhoneOptions.length > 0) {
				this.fieldPhoneOptions = JSON.parse(data.fieldPhoneOptions);
			} else {
				let option = {
					label: "",
					visible: true,
					value: ""
				}
				this.fieldSelectOptions.push(option);
			}
		});
	}

	ngOnInit() {
		if (this.data.type) {
			this.fieldType = this.data.type;
		}
	}

	ngAfterContentInit() {
		// Observer for formbuilder node
		const formBuilderNode = document.getElementById('formbuilder');
		const formBuilderConfig = { attributes: true, childList: true, subtree: true };
		const formBuilderCallback = function (mutationsList, observer) {
			if (this.iteration) {
				let update = document.getElementById("update");
				update["disabled"] = false;
				update["style"]["opacity"] = "";
				observer.disconnect();
			}
			this.iteration = true;
		};
		const formBuilderObserver = new MutationObserver(formBuilderCallback);
		formBuilderObserver.observe(formBuilderNode, formBuilderConfig);
	}

	formatPhone(phone: string) {
		const cleaned = phone.replace(/\D/g, ""); // Remove all non-digits including '+'
		const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/); // 1-digit country code
		return match ? `${match[1]} (${match[2]}) ${match[3]}-${match[4]}` : phone;
	}

	FieldTitleChange(value): void {
		this.error = "";
		// let elementId = "#" + this.data.element;
		// $(elementId + ' :input').attr('placeholder', value);
		// let element = $(elementId);
		// element[0].children[1].innerText = value;
		// $(elementId + ' :input').attr('outerText', value);
		// $(elementId + ' :input').attr('data-placeholder', value);
		// $(elementId + ' :input').attr('data-label', value);
		this.fieldTitle = value;
	}

	FieldValidationChange(event): void {
		// let elementId = "#" + this.data.element;
		// $(elementId + ' :input').attr('data-required', event.currentTarget.checked);
		this.fieldRequired = event.currentTarget.checked;
	}


	optionValueChange(index, type, value): void {
		if (this.fieldType === 'radio') {
			if (type === 'label') {
				this.fieldOptions[index].label = value;
				this.fieldOptions[index].value = (value).toLowerCase();
			} else {
				this.fieldOptions[index].visible = value;
			}
		} else if (this.fieldType === 'select') {
			if (type === 'label') {
				this.fieldSelectOptions[index].label = value;
				this.fieldSelectOptions[index].value = (value).toLowerCase();
			} else {
				this.fieldSelectOptions[index].visible = value;
			}
		} else if (this.fieldType === 'checkbox') {
			this.defaultValue = value;
		} else if (this.fieldType === 'topic' || this.fieldType === 'subtopic') {
			this.fieldEmailOptions[index].email = value;
		} else if (this.fieldType === 'topic-phone' || this.fieldType === 'subtopic-phone') {
			let phone = new AsYouType('US').input(value);
			this.fieldPhoneOptions[index].phone = phone;
		}
	}

	addNewOption(): void {
		let option = {
			label: "",
			visible: true,
			value: ""
		}
		this.fieldOptions.push(option);
	}

	addNewSelectOption(): void {
		let option = {
			label: "",
			visible: true,
			value: ""
		}
		this.fieldSelectOptions.push(option);
	}

	addNewEmailOption(): void {
		let option = {
			email: ""
		}
		this.fieldEmailOptions.push(option);
	}

	addNewPhoneOption(): void {
		let option = {
			phone: ""
		}
		this.fieldPhoneOptions.push(option);
	}

	onNoClick(): void {
		this.ngZone.run(() => {
			if (this.fieldType === "topic" || this.fieldType === "subtopic") {
				let validityCheck = true;
				if (this.fieldEmailOptions.length === 0) {
					(Window as any).app?.onSaveElementMoved?.(null);
					this.dialogRef.close();
				}
				if (this.fieldEmailOptions.length > 0) {
					this.fieldEmailOptions.forEach((option) => {
						if (option.email.length === 0) {
							this.openSnackBar("Email field cannot be left empty");
							validityCheck = false;
							return;
						}
						if (option.email.length !== 0) {
							const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
							let valid = re.test(String(option.email).toLowerCase());
							if (!valid) {
								this.openSnackBar(option.email + " is not a valid email");
								validityCheck = false;
								return;
							}
						}
					});
				}
				if (validityCheck) {
					let currentTopicElement = document.getElementById(this.data.element);
					let emails = this.fieldEmailOptions.filter((element) => element.email !== "");
					this.fieldType === "topic" ? currentTopicElement.children[3]["setAttribute"]("data-options-email", JSON.stringify(emails)) : currentTopicElement.children[2]["setAttribute"]("data-options-email", JSON.stringify(emails));
					(Window as any).app?.onSaveElementMoved?.(null);
					this.dialogRef.close();
					return;
				} else {
					return;
				}
			}

			if (this.fieldType === "topic-phone" || this.fieldType === "subtopic-phone") {
				let validityCheck = true;
				if (this.fieldPhoneOptions.length === 0) {
					(Window as any).app?.onSaveElementMoved?.(null);
					this.dialogRef.close();
				}
				if (this.fieldPhoneOptions.length > 0) {
					this.fieldPhoneOptions.forEach((option) => {
						if (option.phone.length === 0) {
							this.openSnackBar("Phone Number field cannot be left empty");
							validityCheck = false;
							return;
						}
						if (option.phone.length !== 0) {
							let parsedPhone = parsePhoneNumber(option.phone, 'US');
							const re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
							let nationalNumber = parsedPhone.formatNational();
							let valid = re.test(nationalNumber);
							if (!valid) {
								this.openSnackBar(option.phone + " is not a valid phone number");
								validityCheck = false;
								return;
							}
						}
					});
				}
				if (validityCheck) {
					let currentTopicElement = document.getElementById(this.data.element);
					// let phoneNumbers = this.fieldPhoneOptions.filter((element) => element.phone !== "");
					let phoneNumbers = this.fieldPhoneOptions
						.filter((element) => element.phone !== "")
						.map((element) => {
							let cleaned = element.phone.replace(/\D/g, ""); // Remove non-digits

							// Ensure country code starts with 1 (US default)
							if (!cleaned.startsWith("1")) {
								cleaned = "1" + cleaned;
							}

							return {
								phone: "+" + cleaned
							};
						});
					this.fieldType === "topic-phone" ? currentTopicElement.children[3]["setAttribute"]("data-options-phone", JSON.stringify(phoneNumbers)) : currentTopicElement.children[2]["setAttribute"]("data-options-phone", JSON.stringify(phoneNumbers));
					(Window as any).app?.onSaveElementMoved?.(null);
					this.dialogRef.close();
					return;
				} else {
					return;
				}
			}

			// Updating field title
			let elementId = "#" + this.data.element;
			let element = $(elementId);
			element[0].children[1].innerText = this.fieldTitle;
			$(elementId + ' :input').attr('outerText', this.fieldTitle);
			$(elementId + ' :input').attr('data-placeholder', this.fieldTitle);
			$(elementId + ' :input').attr('data-label', this.fieldTitle);

			// Updating validations
			// let elementId = "#" + this.data.element;
			$(elementId + ' :input').attr('data-required', this.fieldRequired);

			if (this.fieldType === 'radio') {
				let elementId = "#" + this.data.element;
				if (this.fieldOptions.length > 0) {
					for (let i = 0; i < this.fieldOptions.length; i++) {
						if (this.fieldOptions[i]["label"].length === 0) {
							this.fieldOptions.splice(i, 1);
						}
					}
				}
				$(elementId + ' :input').attr('data-options', JSON.stringify(this.fieldOptions));
			} else if (this.fieldType === 'checkbox') {
				let elementId = "#" + this.data.element;
				$(elementId + ' :input').attr('data-options', this.defaultValue);
			} else if (this.fieldType === 'select') {
				let elementId = "#" + this.data.element;
				if (this.fieldSelectOptions.length > 0) {
					for (let i = 0; i < this.fieldSelectOptions.length; i++) {
						if (this.fieldSelectOptions[i]["label"].length === 0) {
							this.fieldSelectOptions.splice(i, 1);
						}
					}
					$(elementId + ' :input').attr('data-options', JSON.stringify(this.fieldSelectOptions));
				} else {
					$(elementId + ' :input').attr('data-options', JSON.stringify(this.fieldSelectOptions));
				}
			}
			(Window as any).app?.onSaveElementMoved?.(null);
			this.dialogRef.close();
		});
	}

	openSnackBar(message) {
		this._snackBar.open(message, "Ok", {
			duration: 2000
		});
	}

	closeDialog(): void { // Closes the dialog on cancel click
		if (this.data.new) {
			let field = document.getElementById(this.data.element)
			field.remove();
			this.dialogRef.close();
			return;
		}
		this.dialogRef.close();
	}
}
